import { useMutation, useQuery } from '@apollo/client'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import {
  CREATE_PROVIDER,
  GET_PROVIDER_BY_ID,
  GET_TYPE_PROVIDERS,
  UPDATE_PROVIDER,
} from '../../../../graphql/Catalog/Providers/providers'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { FormProvider, useForm } from 'react-hook-form'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import Cropper from 'react-cropper'
import ModalContent from '../../../Global/ModalContent'
import ContentHeader from '../../../Layout/ContentHeader'
import { AuthContext } from '../../../../Auth/AuthContext'
import CameraIcon from '../../../../Assets/icons/Icon material-add-a-photo.svg'

const ProvidersNew = () => {
  const { user } = useContext(AuthContext)
  const refCropper = useRef(null)
  const refModalCropper = useRef(null)

  const { id: _id } = useParams()
  const history = useHistory()
  const { hideLoading, showLoading } = useLoading()

  const [typeOptions, setTypeOptions] = useState([])
  const [logo, setLogo] = useState([])
  const [imageSrc, setImageSrc] = useState(null)
  const [dimensions, setDimensions] = useState(null)
  const [loadedImage, setLoadedImage] = useState(false)
  const [isDragging, setIsDragging] = useState(false)
  const [provider, setProvider] = useState({})

  const validationSchema = Yup.object().shape({
    card_name: Yup.string().required('Campo requerido'),
    rfc: Yup.string().required('Campo requerido'),
    ///^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/
    // .matches(/^[A-Z]{4}[0-9]{6}[A-Z0-9]{0,3}$/, 'RFC inválido')
    // .min(10, 'Mínimo 10 caracteres')
    // .max(13, 'Máximo 13 caracteres'),
    type: Yup.string().required('Campo requerido'),
    card_code: Yup.string(),
    email: Yup.string().email('Correo inválido'),
    phone: Yup.string()
      .required('Campo requerido')
      .matches(/^[0-9]{10}$/, 'Número inválido')
      .max(10, 'Máximo 10 caracteres'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const { loading, error, data } = useQuery(GET_PROVIDER_BY_ID, {
    variables: {
      getProviderByIdId: +_id,
    },
    fetchPolicy: 'no-cache',
    skip: !_id,
  })

  const {
    loading: loadingTypes,
    error: errorTypes,
    data: dataTypes,
  } = useQuery(GET_TYPE_PROVIDERS, {
    fetchPolicy: 'cache-and-network',
  })

  const [createProvider] = useMutation(CREATE_PROVIDER)
  const [updateProvider] = useMutation(UPDATE_PROVIDER)

  useEffect(() => {
    if (imageSrc) {
      setTimeout(() => {
        refCropper.current?.cropper?.reset()
        refCropper.current?.cropper?.resize()
      }, 1000)
      document.getElementById(`spanModalCropper`).click()
    }
  }, [imageSrc])

  useEffect(() => {
    try {
      if (!_id) return

      if (user && user.provider_id) {
        if (user.provider_id !== +_id) {
          return toastSweetAlert(
            {
              mode: 'error',
              message: 'No tienes permisos para editar este proveedor',
            },
            history.push('/providers')
          )
        }
      }

      if (loading) return
      if (error) throw error
      if (!data) throw new Error('No se encontraron datos')

      const { getProviderById } = data

      reset({
        card_name: getProviderById.card_name,
        rfc: getProviderById.rfc,
        type: getProviderById.type,
        card_code: getProviderById.card_code,
        email: getProviderById.email,
        phone: getProviderById.phone,
      })

      if (getProviderById.logo) {
        setLogo([
          {
            name: 'logo.png',
            data: getProviderById.logo,
          },
        ])
      }

      setProvider(getProviderById)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    try {
      if (loadingTypes) return
      if (errorTypes) throw errorTypes
      if (!dataTypes) throw new Error('No se encontraron datos')

      const { getTypesForProvider } = dataTypes

      setTypeOptions(getTypesForProvider)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataTypes, errorTypes, loadingTypes])

  const handleDrop = (e) => {
    e.preventDefault()
    if (logo.length >= 1)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo puedes subir una imagen',
      })

    const file = e.dataTransfer.files[0]

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg']

    if (!allowedTypes.includes(file.type)) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Este tipo de archivo no esta permitido',
      })
    }

    const allowedSize = 1024 * 1024 * 5

    if (file.size > allowedSize) {
      return toastSweetAlert({
        mode: 'error',
        message: 'El archivo es muy grande',
      })
    }

    const reader = new FileReader()
    reader.onload = (event) => {
      const img = new Image()

      img.src = event.target.result

      img.onload = () => {
        setDimensions({
          width: img.width,
          height: img.height,
        })
      }

      img.onerror = () => {
        return toastSweetAlert({
          mode: 'error',
          message: 'El archivo no es una imagen válida o está dañado',
        })
      }

      setImageSrc(reader.result)
      setLogo((prev) => {
        return {
          ...prev,
          file: file,
        }
      })
    }
    reader.readAsDataURL(file)
    handleDragLeave()
  }
  const handleDragOver = (e) => {
    e.preventDefault()

    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault()
        dropzone.classList.add('dragging')
        setIsDragging(true)
      })
    }
  }

  const handleDragLeave = (e) => {
    // e.preventDefault()
    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.classList.remove('dragging')
      setIsDragging(false)
    }
  }

  const handleRemoveFile = (index) => {
    const newLogo = [...logo]
    newLogo.splice(index, 1)
    setLogo(newLogo)
    setImageSrc(null)
  }

  const handleCrop = () => {
    if (refCropper.current) {
      const cropper = refCropper.current.cropper
      const croppedCanvas = cropper.getCroppedCanvas()
      const croppedImage = croppedCanvas.toDataURL('image/png')

      setLogo((prev) => {
        return [
          {
            ...prev,
            name: 'logo.png',
            data: croppedImage,
          },
        ]
      })
      // [{ name: 'logo-recortado.png', data: croppedImage }]
      setTimeout(() => {
        refModalCropper.current.click()
      }, 200)
    }
  }

  const handleEditCrop = (index) => {
    // setImageSrc(logo[index].data)

    document.getElementById(`spanModalCropper`).click()
  }

  const removeSkeleton = (e) => {
    const skeleton = document.getElementById('skeleton-image')
    if (skeleton) {
      skeleton.style.display = 'none'
    }
  }

  const onSubmit = async (data) => {
    showLoading()
    try {
      let image = null
      const base64Regex = /^(data:\w+\/[a-zA-Z+\-.]+;base64,)?[A-Za-z0-9+/=]+$/
      if (logo.length > 0) {
        if (base64Regex.test(logo[0].data)) {
          const imageBase64 = logo[0].data.split(',')[1]
          const byteCharacters = atob(imageBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)

          image = new Blob([byteArray], { type: 'image/png' })
        }
      }

      if (_id) {
        const { data: dataUpdate } = await updateProvider({
          variables: {
            updateProviderId: +_id,
            provider: {
              card_name: data.card_name,
              rfc: data.rfc,
              type: data.type,
              card_code: data.card_code,
              email: data.email,
              phone: data.phone,
              logo: image,
            },
          },
        })

        if (dataUpdate.updateProvider) {
          return toastSweetAlert(
            {
              mode: 'ok',
              message: 'Proveedor actualizado correctamente',
            },
            history.push('/providers')
          )
        }
      }

      const { data: dataCreate } = await createProvider({
        variables: {
          provider: {
            card_name: data.card_name,
            rfc: data.rfc,
            type: data.type,
            card_code: data.card_code,
            email: data.email,
            phone: data.phone,
            logo: image,
          },
        },
      })

      if (dataCreate.createProvider) {
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Proveedor creado correctamente',
          },
          history.push('/providers')
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader breadcrumb="" title="" windowTitle="Proveedores" />

      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            {/* <Link
              className="btn btn-migrates-white mb-3"
              to={`/providers`}
            >
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link> */}
            <h1 className="header-title">
              {' '}
              {_id
                ? `Editar proveedor ${provider && provider.card_name}`
                : 'Agregar proveedor'}
            </h1>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={'Detalles del proveedor'}
            btnSubmit
            clasCard='card report-providers'
            btnSubmitText={_id ? 'Editar Proveedor' : 'Agregar Proveedor'}
            // btnRedPath="/providers"
            // btnRedTxt="Cancelar"
            content={
              <>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <InputController
                      name="card_name"
                      control={control}
                      label="Nombre"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController name="rfc" control={control} label="RFC" />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      name="type"
                      control={control}
                      label="Tipo"
                      inputType="choosen"
                      options={typeOptions}
                      placeholderTxt="Seleccione un tipo"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      name="card_code"
                      control={control}
                      label="Código"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      name="email"
                      control={control}
                      label="Correo"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      name="phone"
                      control={control}
                      label="Teléfono"
                    />
                  </div>

                  <div className="col-12 container-drag-drop container-drag-drop-medium mb-3">
                    <div className='w-100 d-flex justify-content-between'>
                      <label htmlFor="dropzone">Archivos adjuntos</label>
                      <label htmlFor="dropzone" className='text-end'>
                        {logo.length}/1
                        {/* {maxFiles > 1 ? ' archivos' : ' archivo'} */}
                      </label>
                    </div>
                    <div
                      className="dropzone max-size-provider"
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                    >
                      {logo.length > 0 ? (
                        <div className="dropzone-image-container">
                          {logo.map((file, index) => (
                            <div
                              key={index}
                              className="dropzone-container-image"
                              style={{
                                textAlign: 'center',
                                position: 'relative',
                                gap: '5px',
                                borderRadius: '5px',
                              }}
                            >
                              {imageSrc && (
                                <span
                                  onClick={() => handleEditCrop(index)}
                                  className="dropzone--edit-button"
                                >
                                  <i className="fas fa-edit"></i>
                                </span>
                              )}
                              <button
                                onClick={() => handleRemoveFile(index)}
                                className="dropzone--delete-button"
                              >
                                ×
                              </button>
                              <img
                                src={file.data}
                                alt={file.name}
                                className="dropzone-image"
                                onLoad={() => removeSkeleton()}
                              />
                              <p className="dropzone-filename">{file.name}</p>
                              <div
                                id="skeleton-image"
                                className="skeleton-image"
                              ></div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="dropzone-content">
                          {isDragging ? (
                            <div className="dropzone-dragging">
                              <i className="fas fa-cloud-upload-alt dropzone-icon"></i>
                              <p className="dropzone-text">Suelta el archivo</p>
                            </div>
                          ) : (
                            <div className="dropzone-message">
                              <img src={CameraIcon} alt="camera-icon" /> 
                              <p className="dropzone-text">
                                Arrastra y suelta el archivo aquí
                              </p>
                              <p className='dropzone-text-subtitle'>
                                Formatos permitidos: .png, .jpeg, .jpg - Tamaño
                                máximo: 5MB
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <span
                  id={`spanModalCropper`}
                  data-toggle="modal"
                  data-target="#modalCropper"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-dismiss="modal"
                  ref={refModalCropper}
                ></span>

                <ModalContent
                  idModal="modalCropper"
                  title="Recortar imagen"
                  size="large"
                  // onClose={}
                  content={
                    <>
                      {imageSrc && (
                        <div style={{ marginTop: '20px' }}>
                          <Cropper
                            src={imageSrc}
                            style={{ height: 400, width: '100%' }}
                            // aspectRatio={
                            //   document.body.clientWidth < 768 ? 1 : 2
                            // }
                            // viewMode={document.body.clientWidth < 768 ? 1 : 2}
                            // autoCropArea={1}
                            responsive={true}
                            // checkOrientation={false}
                            guides={true}
                            accept="image/*"
                            ref={refCropper}
                            onCrop={handleCrop}
                          />
                          <span
                            onClick={handleCrop}
                            className="btn btn-sm btn-migrates"
                            style={{
                              marginTop: '10px',
                              display: 'block',
                            }}
                          >
                            Recortar y guardar
                          </span>
                        </div>
                      )}
                    </>
                  }
                />
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default ProvidersNew
